import { Search, X } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useCallback, type ChangeEvent } from 'react'

interface SearchInputProps {
  value?: string
  placeholder?: string
  className?: string
  onChange?: (value: string) => void
  onClear?: () => void
}

export function SearchInput({
  value = '',
  placeholder = 'Search',
  className,
  onChange,
  onClear,
}: SearchInputProps) {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value)
    },
    [onChange]
  )

  const handleClear = useCallback(() => {
    onChange?.('')
    onClear?.()
  }, [onChange, onClear])

  return (
    <div className={cn('relative', className)}>
      <Search
        strokeWidth={2}
        className="absolute left-2 top-1/2 h-3 w-3 -translate-y-1/2 text-primary"
      />
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        className="h-8 py-0 pl-6 pr-2 shadow-none rounded-md border-border font-univers !text-xs text-primary placeholder:!text-xs placeholder:text-primary/80 flex items-center"
      />
      {value && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1/2 h-7 w-7 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          onClick={handleClear}
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Clear search</span>
        </Button>
      )}
    </div>
  )
}
